export const addChannelFlowSteps = {
  SELECT_CHANNEL_STEP: 0,
  CONSENT_FORM_STEP: 1,
  DYNAMIC_FORM_STEP: 2,
};
